import { MeshGroup } from "@/3d/meshGroup/MeshGroup";
import { useEditorState } from "@/state/editorState";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Vector3 } from "three";
import { MeshGroupGeneralSettings } from "./MeshGroupGeneralSettings";
import { ensureUniqueName } from "@/utils/string";
import { MeshGroupMeshSettings } from "./MeshGroupMeshSettings";

export const MeshGroupsEditor = () => {
    const [selectedGroupId, setSelectedGroupId] = useState<string>();
    const meshGroups = useEditorState((state) => state.meshGroups);
    const setMeshGroups = useEditorState((state) => state.setMeshGroups);

    const selectedGroup = selectedGroupId ? meshGroups[selectedGroupId] : undefined;

    const handleAddGroup = () => {
        const newGroup: MeshGroup = {
            id: uuidv4(),
            name: ensureUniqueName(
                "New Group",
                Object.values(meshGroups).map((g) => g.name)
            ),
            meshNames: [],
            meshPositions: {},
            meshRotations: {},
            position: new Vector3(),
            rotation: new Vector3(),
        };

        setMeshGroups({ ...meshGroups, [newGroup.id]: newGroup });
        setSelectedGroupId(newGroup.id);
    };

    const handleDeleteGroup = (groupId: string) => {
        const newGroups = { ...meshGroups };
        delete newGroups[groupId];
        setMeshGroups(newGroups);
        if (selectedGroupId === groupId) {
            setSelectedGroupId(undefined);
        }
    };

    const handleGroupChange = (group: MeshGroup) => {
        setMeshGroups({ ...meshGroups, [group.id]: group });
    };

    return (
        <div className="d-flex flex-column gap-2 overflow-auto">
            <div>
                <b>Mesh Groups</b>
            </div>
            <div className="mb-3 d-flex flex-column gap-2">
                <select
                    className="form-select"
                    value={selectedGroupId || ""}
                    onChange={(e) => setSelectedGroupId(e.target.value)}
                >
                    <option value="">Select a group...</option>
                    {Object.values(meshGroups).map((group) => (
                        <option key={group.id} value={group.id}>
                            {group.name}
                        </option>
                    ))}
                </select>
                <div className="d-flex gap-2">
                    <button className="btn btn-primary" onClick={handleAddGroup}>
                        Add Group
                    </button>
                    {selectedGroupId && (
                        <button
                            className="btn btn-danger"
                            onClick={() => handleDeleteGroup(selectedGroupId)}
                        >
                            Delete Group
                        </button>
                    )}
                </div>
            </div>

            {selectedGroup && (
                <>
                    <MeshGroupGeneralSettings group={selectedGroup} onChange={handleGroupChange} />
                    <MeshGroupMeshSettings group={selectedGroup} onChange={handleGroupChange} />
                </>
            )}
        </div>
    );
};
